import { APIClient } from "api/api_helper";
import { LINE_CLEARANCE_API } from "api/url_helper";
import { CurrentUser, GetUserData } from "common/service/CommonService";

const api = new APIClient();

export const lineApiService = {
  insertData: (payload_data: any) => {
    const user = GetUserData() as CurrentUser;

    const payload = {
      createdby: user?.userid,
      ...payload_data,
    };

    return api.create(LINE_CLEARANCE_API.LINE_CLEARANCE_API + "Insert", payload);
  },

  selectAllData: (
    searchtext?: string | null,
    currentpage: number = 1,
    pagesize: number = 5,
    studyid?: number | null,
    periodid?: number | null
  ) => {
    const payload = {
      searchtext: searchtext || "",
      currentpage: currentpage,
      pagesize: pagesize,
      studyid: studyid || null,
      periodid: periodid || null,
    };
    return api.create(LINE_CLEARANCE_API.LINE_CLEARANCE_API + "SelectAll", payload);
  },

  selectData: (lineclearanceid?: number | null) => {
    const payload = {
      lineclearanceid: lineclearanceid || null,
    };
    return api.create(LINE_CLEARANCE_API.LINE_CLEARANCE_API + "Select", payload);
  },

  updateData: (payload_data: any) => {
    return api.create(LINE_CLEARANCE_API.LINE_CLEARANCE_API + "Update", payload_data);
  },

  deleteData: (payload_data: { lineclearanceid: number | null; updatereason: string }) => {
    const user = GetUserData() as CurrentUser;

    const payload = {
      lineclearanceid: payload_data.lineclearanceid,
      updatereason: payload_data.updatereason,
      updatedby: user?.userid,
    };

    return api.create(LINE_CLEARANCE_API.LINE_CLEARANCE_API + "Delete", payload);
  },

  verifyPin: (payload: { verifypin: string; lineclearanceid: number; studyid: number; verifiedby: number }) => {
    return api.create(LINE_CLEARANCE_API.LINE_CLEARANCE_API + "Verify", payload);
  },

  Dropdown: () => {
    return api.create(LINE_CLEARANCE_API.LINE_CLEARANCE_API + "Dropdown", {});
  },
};
